import { createSlice } from "@reduxjs/toolkit";

export const initialState = {

    loginData: {
        user: {

        },
        token: "",
        userId: 0,

    },
    aesKey: "",
    isJwtToken: false,
    user: {},
    sideBarOpen: false,
    isLogin: false,
    loader: false,
    menuButton: false,
    menuList: [],
    editTable: false,
    roleId: 0,


}


const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setSidebarOpen: (state, { payload }) => {
            state.sideBarOpen = payload;

        },
        setUserData: (state, { payload }) => {
            state.user = payload
        },
        setisLoginUser: (state, { payload }) => {
            state.isLogin = payload;
        },
        setLoader: (state, { payload }) => {
            state.loader = payload
        },
        setMenuButton: (state, { payload }) => {
            state.menuButton = payload;
        },

        setIsJwtToken: (state, { payload }) => {
            state.isJwtToken = payload;
        },


        setToken: (state, { payload }) => {
            state.loginData.token = payload
        },
        setUserId: (state, { payload }) => {
            state.loginData.userId = payload
        },
        setAesKey: (state, { payload }) => {
            state.aesKey = payload;
        },

        setList: (state, { payload }) => {
            state.menuList = payload;
        },
        setRoleId: (state, { payload }) => {
            state.roleId = payload;

        },


        setEditTable: (state, { payload }) => {
            state.editTable = payload
        }



    }
})


export const {
    setSidebarOpen,
    setUserData,
    setisLoginUser,
    setLoader,
    setMenuButton,
    setUserId,
    setToken,
    setIsJwtToken,
    setAesKey,
    setList,
    setEditTable,
    setRoleId
} = authSlice.actions;


export default authSlice.reducer;
